/**
 * @class
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/optionTile';
import Menu from '@netx/core/lib/netx-menu';

class OptionTiles extends Base {
	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;

		const menu = opts.menu;
		// Must be a valid menu
		if (menu == null || !(menu instanceof Menu)) {
			throw new Error('A valid menu is required for Option Tiles');
		}

		const actions = menu.get('actions');
		models = [];
		_.each(actions, (action) => {
			const tileOption = new opts.model({action: action}, _.omit(opts, 'menu'));
			// If there is no event on our model there must have been issues or this use ris not allowed to run the action provided
			// In any case, do not add to the collection
			if (tileOption.get('event')) models.push(tileOption);
		});

		super(models, opts);

		if (menu && menu.get) {
			this.label = menu.get('label') || i18n.t('i18n.options');
		}
	}

	/** @type {string} */
	static get __name__() {
		return 'OptionTiles';
	}
}

export default OptionTiles;
